import FadeInHOC from '@components/FadeInHOC'
import AboutSubMenu from '@components/about/AboutSubMenu'
import Image from 'next/legacy/image'
import * as React from 'react'
import { Visible, config } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import BackgroundGradient from '@components/BackgroundGradient'

type PropsType = {
  setLoadingComplete: () => void,
  takeMeThere: (id: string) => void,
  isMenuVisible: boolean
}

export default function AboutHeaderSection (props: PropsType): React.ReactNode {
  const { setLoadingComplete, takeMeThere, isMenuVisible } = props

  return (
    <Section>
      <BackgroundGradient
        loadingComplete={setLoadingComplete}
        quadrant={2}
        overlayColor='magenta'
        parallax
      />
      <Main>
        <Content>
          <FadeInHOC uniqueId="about-hero">
            <>
              <Visible xs sm md={false} lg={false} xl={false}>
                <HeroImage
                  src="/images/about-hero-mobile.png"
                  height={228}
                  width={375}
                  setLoadingComplete={setLoadingComplete}
                />
              </Visible>
              <Visible xs={false} sm={false} md lg xl>
                <HeroImage
                  src="/images/about-hero-desktop.png"
                  height={380}
                  width={1494}
                  setLoadingComplete={setLoadingComplete}
                />
              </Visible>
            </>
          </FadeInHOC>
          {isMenuVisible && (
            <FadeInHOC uniqueId="about-sub-menu">
              <AboutSubMenu takeMeThere={takeMeThere} />
            </FadeInHOC>
          )}
        </Content>
      </Main>
    </Section>
  )
}

const Section = styled.section<any>`
  margin: -75px 0 0;
  position: relative;
`
const Main = styled.div<any>`
  padding: 75px 0 0;
`

const Content = styled.div<any>`
  padding: 59px 0;
  ${config().media.md`
    padding: 78px 0;
  `}
  ${config().media.lg`
    padding: 92px 0;
  `}
`

type HeroImagePropsType = {
  src: string,
  height: number,
  width: number,
  setLoadingComplete: () => void
}

const HeroImage = ({ src, height, width, setLoadingComplete }: HeroImagePropsType): React.ReactNode => (
  <Image
    className="hero-image"
    src={src}
    aria-hidden="true"
    height={height}
    width={width}
    layout="responsive"
    loader={(): string => src}
    onLoadingComplete={setLoadingComplete}
  />
)
